// extracted by mini-css-extract-plugin
export var table = "_vk-0";